import { shallowRef } from 'vue';
import type { RouteRecordRaw } from 'vue-router';

import { PAGES as ROOT_PAGES } from '@utils/constants';
import type { Module } from '@utils/model';

import { PAGES } from './constants';

import ModuleIcon from '~icons/mdi/car-wrench';

const routes: RouteRecordRaw[] = [
	{
		path: '/service-intervals-catalog',
		name: PAGES.HOME,
		component: () => import('./pages/index.vue'),
		meta: {
			isAllowed: ({ canAccessServiceIntervalsCatalog }) => canAccessServiceIntervalsCatalog || ROOT_PAGES.MODULES,
			documentTitle: 'Service intervals catalog',
			title: 'Service intervals catalog',
		},
	},
];

/** Not built here: motorway/mw-vehicle-history (apps/service-intervals-catalog), loaded at runtime as a Module Federation remote. */
export const SERVICE_INTERVALS_CATALOG_MODULE: Module = {
	id: PAGES.HOME,
	link: { name: PAGES.HOME },
	title: 'Service intervals catalog',
	description: 'Service interval for every make, range, series and model code',
	icon: shallowRef(ModuleIcon),
	enabled: ({ canAccessServiceIntervalsCatalog }) => canAccessServiceIntervalsCatalog,
	routes,
};
